import { getEntityViewStateEntityId } from "src/entityView/selector";
import actionCreatorFactory from "typescript-fsa";
import { asyncFactory, thunkToAction } from "typescript-fsa-redux-thunk";
import api from "../api";
import { State } from "../state";

import { getUser } from "src/login/selector";
import { getMetadataPaginationPageSize } from "src/metadata/selector";
import { isCreditLensFeatureEnabled } from "../configState/selector";
import {
  getBriefSpreadFilter,
  getBriefSpreadPage,
  getBriefSpreadQuery,
  getBriefSpreadSort,
  getBriefSpreadStatusGroup
} from "./selector";
import {
  BriefSpread,
  BriefSpreadResponse,
  Pagination,
  Search,
  SPREAD_COLUMNS,
  SpreadFilter,
  SpreadStatusGroup,
  Tab
} from "./types";

const create = actionCreatorFactory("BriefSpread");

const createAsync = asyncFactory<State>(create);

// tslint:disable-next-line: no-empty-interface
export interface LoadBriefSpreadsParams {}

export interface LoadBriefSpreadsSuccessParams {
  briefSpread: BriefSpreadResponse;
}

const getBriefSpreads = async (
  params: LoadBriefSpreadsParams,
  dispatch: any,
  getState: () => State
) => {
  const briefSpread = await api.briefSpread.get(
    getUser(getState()).isBankAnalyst,
    getBriefSpreadSort(getState()),
    getEntityViewStateEntityId(getState()),
    getBriefSpreadFilter(getState()),
    getMetadataPaginationPageSize(getState()),
    getBriefSpreadPage(getState()),
    getBriefSpreadQuery(getState()),
    getBriefSpreadStatusGroup(getState())
  );
  return { briefSpread };
};

export const loadBriefSpreads = createAsync<
  LoadBriefSpreadsParams,
  LoadBriefSpreadsSuccessParams
>("LOAD", getBriefSpreads);
const loadBriefSpreadsAction = thunkToAction(loadBriefSpreads.action);
export type LoadBriefSpreadsActionType = typeof loadBriefSpreadsAction;

export const reloadBriefSpreads = createAsync<
  LoadBriefSpreadsParams,
  LoadBriefSpreadsSuccessParams
>("RELOAD", getBriefSpreads);
const reloadBriefSpreadsAction = thunkToAction(reloadBriefSpreads.action);
export type ReloadBriefSpreadsActionType = typeof reloadBriefSpreadsAction;

export const resetBriefSpread = create("RESET_BRIEF_SPREAD");

export interface DeleteSpreadParams {
  spreadId: string;
}

export interface DeleteSpreadSuccess {
  briefSpread: BriefSpread[];
}

export const deleteSpread = createAsync<
  DeleteSpreadParams,
  DeleteSpreadSuccess
>("DELETE_SPREAD", async (params, dispatch, getState) => {
  const briefSpread = await api.briefSpread.deleteSpread(
    params.spreadId,
    isCreditLensFeatureEnabled(getState()),
    getBriefSpreadSort(getState())
  );
  dispatch({
    payload: { lastUsed: new Date().getTime().toString() },
    type: "UPDATE_LAST_USED"
  });
  return { briefSpread };
});
const deleteSpreadAction = thunkToAction(deleteSpread.action);
export type DeleteSpreadActionType = typeof deleteSpreadAction;

export const updateSort = create<SPREAD_COLUMNS>("UPDATE_SORT");
export const updatePage = create<Pagination>("UPDATE_PAGE");
export const updateFilter = create<SpreadFilter>("UPDATE_FILTER");
export const updateStatusGroup = create<SpreadStatusGroup>(
  "UPDATE_STATUS_GROUP"
);
export const updateSearch = create<Search>("UPDATE_SEARCH");
export const updateActiveTab = create<Tab>("UPDATE_TAB");



// WEBPACK FOOTER //
// ./src/documentList/actions.ts